import { render } from "./ClientView.vue?vue&type=template&id=fad15226&scoped=true"
import script from "./ClientView.vue?vue&type=script&lang=js"
export * from "./ClientView.vue?vue&type=script&lang=js"

import "./ClientView.vue?vue&type=style&index=0&id=fad15226&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fad15226"]])

export default __exports__